
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.834 2.5c0-.369.299-.667.667-.667h4c.367 0 .666.3.666.667v4a.667.667 0 11-1.333 0V3.167H9.5a.667.667 0 01-.667-.667z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.972 2.028c.26.26.26.683 0 .943l-5 5a.667.667 0 11-.943-.943l5-5c.26-.26.683-.26.943 0z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.167 5.166h4.334a.667.667 0 000-1.333H3A1.167 1.167 0 001.834 5v8a1.167 1.167 0 001.167 1.166h8A1.167 1.167 0 0012.167 13V8.5a.667.667 0 00-1.333 0v4.333H3.167V5.166z","fill":"#282E3E"}})])
          )
        }
      }
    